const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscrepanciesNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20082_5674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H17.5V17.5H0.5V0.5Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70677 13.9497L9.70676 13.9497L9.70391 13.9526C9.33359 14.329 8.89241 14.6283 8.40582 14.8334C7.91922 15.0384 7.39685 15.1451 6.86883 15.1473C6.3408 15.1494 5.81758 15.047 5.32933 14.8459C4.84109 14.6448 4.39748 14.3491 4.02411 13.9757L3.67056 14.3293L4.02411 13.9757C3.65074 13.6023 3.35499 13.1587 3.15391 12.6705C2.95284 12.1823 2.85042 11.659 2.85257 11.131C2.85472 10.603 2.9614 10.0806 3.16644 9.59401C3.37148 9.10742 3.67084 8.66624 4.04724 8.29592L4.04725 8.29594L4.05013 8.29306L4.75708 7.58611L5.11047 7.9395L4.40352 8.64645C4.07851 8.97146 3.8207 9.35731 3.6448 9.78196C3.46891 10.2066 3.37837 10.6617 3.37837 11.1214C3.37837 11.581 3.46891 12.0362 3.6448 12.4608C3.8207 12.8854 4.07851 13.2713 4.40352 13.5963C4.72854 13.9213 5.11438 14.1791 5.53903 14.355C5.96368 14.5309 6.41881 14.6215 6.87845 14.6215C7.33809 14.6215 7.79322 14.5309 8.21787 14.355C8.64252 14.1791 9.02837 13.9213 9.35338 13.5963L10.0603 12.8894L10.4137 13.2428L9.70677 13.9497ZM6.52483 11.1209L11.1212 6.52521L11.4749 6.87898L6.87873 11.4745L6.52483 11.1209ZM12.8892 10.0605L13.5961 9.35356C13.9211 9.02854 14.179 8.6427 14.3549 8.21805C14.5307 7.7934 14.6213 7.33827 14.6213 6.87863C14.6213 6.41899 14.5307 5.96385 14.3549 5.53921C14.179 5.11456 13.9211 4.72871 13.5961 4.4037C13.2711 4.07869 12.8853 3.82087 12.4606 3.64498C12.036 3.46908 11.5808 3.37855 11.1212 3.37855C10.6616 3.37855 10.2064 3.46908 9.78178 3.64498C9.35713 3.82087 8.97129 4.07869 8.64627 4.4037L7.93933 5.11065L7.58593 4.75725L8.29138 4.05181C9.04345 3.31261 10.057 2.90028 11.1116 2.90457C12.1668 2.90887 13.1776 3.32996 13.9237 4.07611C14.6699 4.82227 15.091 5.83304 15.0953 6.88825C15.0995 7.9428 14.6872 8.95635 13.9481 9.70841L13.2426 10.4139L12.8892 10.0605Z",
    fill: "white",
    stroke: "white",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "white",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20082_5674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscrepanciesNav);
export default __webpack_public_path__ + "static/media/discrepancies-nav.babc7989f2b44645ec22b62e0288f668.svg";
export { ForwardRef as ReactComponent };